import React from "react";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import logo from "assets/img/logo-login.png";

class Register extends React.Component {
  componentDidMount() {
    document.body.classList.toggle("register-page");
  }
  componentWillUnmount() {
    document.body.classList.toggle("register-page");
  }
  render() {
    return (
      <div className="register-page">
        <Container>
          <Row>

            <Col className="ml-auto" lg="5" md="5">
              <div className="info-area info-horizontal mt-4">
                <div className="icon icon-primary">
                  <i className="nc-icon nc-money-coins" />
                </div>
                <div className="description">
                  <h5 className="info-title">Crediário Online</h5>
                  <p className="description">
                    Os clientes podem comprar, consultar extrato e ainda quitar 
                    débitos em qualquer uma das lojas da rede.
                  </p>
                </div>
              </div>
              <div className="info-area info-horizontal">
                <div className="icon icon-primary">
                  <i className="nc-icon nc-zoom-split" />
                </div>
                <div className="description">
                  <h5 className="info-title">Consulta de Estoque</h5>
                  <p className="description">
                    Gerencie melhor seu estoque tendo acesso ao estoque de outras
                    lojas direto pelo programa.
                  </p>
                </div>
              </div>
              <div className="info-area info-horizontal">
                <div className="icon icon-info">
                  <i className="nc-icon nc-single-02" />
                </div>
                <div className="description">
                  <h5 className="info-title">Cadastro Centralizado</h5>
                  <p className="description">
                    Informações como: produtos, categorias, comissões, plano de contas 
                    e programação podem ser padronizados.
                  </p>
                </div>
              </div>
              <div className="info-area info-horizontal">
                <div className="icon icon-info">
                  <i className="nc-icon nc-paper" />
                </div>
                <div className="description">
                  <h5 className="info-title">Nota Fiscal de Entrada Online</h5>
                  <p className="description">
                    Você pode dar entrada nas notas direcionando para cada loja através do painel online.
                  </p>
                </div>
              </div>
            </Col>

            <Col className="mr-auto" lg="4" md="6">
              <Card className="card-signup text-center">
                <CardHeader>
                  <CardTitle tag="h4">Cadastrar</CardTitle>
                 
                  <div className="logo">
                      <div className="logo-img">
                        <img src={logo} alt="WebGestor" style={{ width: '40%' }}/>
                      </div>                    
                    </div>
                  
                </CardHeader>

                <CardBody>
                  <Form action="" className="form" method="">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="nc-icon nc-bank" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input placeholder="CNPJ Loja..." type="text" />
                    </InputGroup>

                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="nc-icon nc-single-02" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input placeholder="Nome..." type="text" />
                    </InputGroup>

                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="nc-icon nc-badge" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input placeholder="CPF..." type="text" />
                    </InputGroup>

                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="nc-icon nc-email-85" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input placeholder="Email..." type="email" />
                    </InputGroup>

                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="nc-icon nc-key-25" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Senha..."
                        type="password"
                        autoComplete="off"
                      />
                    </InputGroup>

                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="nc-icon nc-key-25" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Repetir Senha..."
                        type="password"
                        autoComplete="off"
                      />
                    </InputGroup>

                  </Form>
                </CardBody>

                <CardFooter className="mt-0">
                  <Button
                    className="btn-round"
                    color="primary"
                    href="#pablo"
                    onClick={e => e.preventDefault()}
                  >
                    Cadastrar
                  </Button>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url(${require("assets/img/bg/webgestor_login_bg.jpg")})`
          }}
        />
      </div>
    );
  }
}

export default Register;
